import React from 'react'

const ChatBubbleIcon = () => (
  <svg width="18px" height="17px" viewBox="0 0 18 17" version="1.1">
    <title>ic_chat</title>
    <g
      id="Page-1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Late-delivery"
        transform="translate(-1313.000000, -823.000000)"
        fill="#2E4787"
      >
        <g id="footer" transform="translate(571.000000, 813.000000)">
          <g id="chat" transform="translate(726.000000, 0.000000)">
            <g id="ic_chat" transform="translate(16.000000, 10.000000)">
              <path
                d=""
                id="Shape"
                stroke="#2E4787"
                strokeWidth="3.55999994"
                fillRule="nonzero"
              />
              <rect
                id="Rectangle"
                x="7.11572789"
                y="12.3748446"
                width="1.77999997"
                height="2.66999996"
              />
              <polygon
                id="Rectangle"
                points="8.00572787 11.4848446 9.78572784 11.4848446 9.34072785 14.1548446 8.00572787 14.1548446"
              />
              <ellipse
                id="Oval"
                cx="8.45072786"
                cy="7.03484469"
                rx="7.56499988"
                ry="6.2299999"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default ChatBubbleIcon
